var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { faDownload, faEdit, faFileExcel, faFilePdf } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { exportToExcelWithXLSX } from "../helpers/excelExport";
import { exportToPDF } from "../helpers/pdfExport";
export var ExportButton = function (_a) {
    var title = _a.title, _b = _a.data, data = _b === void 0 ? [] : _b, onExcelExport = _a.onExcelExport, onPdfExport = _a.onPdfExport, exportElementId = _a.exportElementId, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.variant, variant = _d === void 0 ? "dropdown" : _d, _e = _a.buttonStyle, buttonStyle = _e === void 0 ? {} : _e, _f = _a.enableFieldCustomization, enableFieldCustomization = _f === void 0 ? false : _f, _g = _a.availableFields, _availableFields = _g === void 0 ? [] : _g, onFieldCustomizationOpen = _a.onFieldCustomizationOpen, _h = _a.hidePdfExport, hidePdfExport = _h === void 0 ? false : _h;
    var _j = useState(false), isDropdownOpen = _j[0], setIsDropdownOpen = _j[1];
    // Default Excel export function
    var handleExcelExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onExcelExport) return [3 /*break*/, 2];
                    return [4 /*yield*/, onExcelExport()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    if (!data || data.length === 0) {
                        alert("No data available to export");
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, exportToExcelWithXLSX({
                            filename: title || "export",
                            data: data,
                            sheetName: "Data",
                        })];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _error_1 = _a.sent();
                    // console.error("Excel export failed:", _error);
                    alert("Excel export failed. Please try again.");
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Default PDF export function
    var handlePdfExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onPdfExport) return [3 /*break*/, 2];
                    return [4 /*yield*/, onPdfExport()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    if (!exportElementId) {
                        alert("No element specified for PDF export");
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, exportToPDF({
                            filename: title || "export",
                            element: exportElementId,
                            orientation: "landscape",
                            format: "a4",
                            quality: 0.95,
                            scale: 2,
                        })];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _error_2 = _a.sent();
                    // console.error("PDF export failed:", _error);
                    alert("PDF export failed. Please try again.");
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var toggleDropdown = function () {
        setIsDropdownOpen(!isDropdownOpen);
    };
    var handleExportAction = function (exportType) {
        if (exportType === "excel") {
            handleExcelExport();
        }
        else {
            handlePdfExport();
        }
        setIsDropdownOpen(false);
    };
    if (variant === "links") {
        return (React.createElement("div", { className: "export-links ".concat(className), style: __assign({ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", marginRight: "16px" }, buttonStyle) },
            !hidePdfExport && (React.createElement("button", { onClick: handlePdfExport, style: {
                    background: "none",
                    border: "1px solid #ccc",
                    color: "#666",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "14px",
                    fontWeight: "400",
                    textDecoration: "none",
                    transition: "all 0.2s ease",
                }, onMouseEnter: function (e) {
                    e.currentTarget.style.borderColor = "#999";
                    e.currentTarget.style.color = "#333";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.borderColor = "#ccc";
                    e.currentTarget.style.color = "#666";
                } },
                React.createElement(FontAwesomeIcon, { icon: faFilePdf }),
                "PDF")),
            enableFieldCustomization && (React.createElement("button", { onClick: onFieldCustomizationOpen, style: {
                    background: "none",
                    border: "1px solid #ccc",
                    color: "#666",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "14px",
                    fontWeight: "400",
                    textDecoration: "none",
                    transition: "all 0.2s ease",
                }, onMouseEnter: function (e) {
                    e.currentTarget.style.borderColor = "#999";
                    e.currentTarget.style.color = "#333";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.borderColor = "#ccc";
                    e.currentTarget.style.color = "#666";
                }, title: "Customize Excel export fields" },
                React.createElement(FontAwesomeIcon, { icon: faEdit }),
                "Edit")),
            React.createElement("button", { onClick: handleExcelExport, style: {
                    background: "none",
                    border: "1px solid #ccc",
                    color: "#666",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "14px",
                    fontWeight: "400",
                    textDecoration: "none",
                    transition: "all 0.2s ease",
                }, onMouseEnter: function (e) {
                    e.currentTarget.style.borderColor = "#999";
                    e.currentTarget.style.color = "#333";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.borderColor = "#ccc";
                    e.currentTarget.style.color = "#666";
                } },
                React.createElement(FontAwesomeIcon, { icon: faFileExcel }),
                "Excel")));
    }
    if (variant === "buttons") {
        return (React.createElement("div", { className: "export-buttons ".concat(className), style: { display: "flex", gap: "8px" } },
            React.createElement("button", { onClick: handleExcelExport, style: __assign({ display: "flex", alignItems: "center", gap: "8px", padding: "8px 16px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "14px", fontWeight: "500" }, buttonStyle), onMouseEnter: function (e) {
                    e.currentTarget.style.backgroundColor = "#218838";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.backgroundColor = "#28a745";
                } },
                React.createElement(FontAwesomeIcon, { icon: faFileExcel }),
                "Export Excel"),
            !hidePdfExport && (React.createElement("button", { onClick: handlePdfExport, style: __assign({ display: "flex", alignItems: "center", gap: "8px", padding: "8px 16px", backgroundColor: "#dc3545", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "14px", fontWeight: "500" }, buttonStyle), onMouseEnter: function (e) {
                    e.currentTarget.style.backgroundColor = "#c82333";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.backgroundColor = "#dc3545";
                } },
                React.createElement(FontAwesomeIcon, { icon: faFilePdf }),
                "Export PDF"))));
    }
    return (React.createElement("div", { className: "export-dropdown ".concat(className), style: { position: "relative", display: "inline-block" } },
        React.createElement("button", { onClick: toggleDropdown, style: __assign({ display: "flex", alignItems: "center", gap: "8px", padding: "8px 16px", backgroundColor: "#007bff", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "14px", fontWeight: "500" }, buttonStyle), onMouseEnter: function (e) {
                if (!isDropdownOpen) {
                    e.currentTarget.style.backgroundColor = "#0056b3";
                }
            }, onMouseLeave: function (e) {
                if (!isDropdownOpen) {
                    e.currentTarget.style.backgroundColor = "#007bff";
                }
            } },
            React.createElement(FontAwesomeIcon, { icon: faDownload }),
            "Export",
            React.createElement("span", { style: { marginLeft: "4px", fontSize: "12px" } }, "\u25BC")),
        isDropdownOpen && (React.createElement("div", { style: {
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                backgroundColor: "white",
                border: "1px solid #ccc",
                borderRadius: "4px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                zIndex: 1000,
                minWidth: "140px",
            } },
            enableFieldCustomization && (React.createElement("button", { onClick: function () {
                    setIsDropdownOpen(false);
                    onFieldCustomizationOpen === null || onFieldCustomizationOpen === void 0 ? void 0 : onFieldCustomizationOpen();
                }, style: {
                    width: "100%",
                    padding: "8px 12px",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#333",
                }, onMouseEnter: function (e) {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.backgroundColor = "transparent";
                }, title: "Customize Excel export fields" },
                React.createElement(FontAwesomeIcon, { icon: faEdit, style: { color: "#666" } }),
                "Edit Fields")),
            React.createElement("button", { onClick: function () { return handleExportAction("excel"); }, style: {
                    width: "100%",
                    padding: "8px 12px",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#333",
                }, onMouseEnter: function (e) {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.backgroundColor = "transparent";
                } },
                React.createElement(FontAwesomeIcon, { icon: faFileExcel, style: { color: "#28a745" } }),
                "Export Excel"),
            !hidePdfExport && (React.createElement("button", { onClick: function () { return handleExportAction("pdf"); }, style: {
                    width: "100%",
                    padding: "8px 12px",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#333",
                }, onMouseEnter: function (e) {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.backgroundColor = "transparent";
                } },
                React.createElement(FontAwesomeIcon, { icon: faFilePdf, style: { color: "#dc3545" } }),
                "Export PDF")))),
        isDropdownOpen && (React.createElement("div", { style: {
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 999,
            }, onClick: function () { return setIsDropdownOpen(false); } }))));
};
export default ExportButton;
